export const themeScreens = {
  tablet: '460px',
  desktop: '1260px'
} as const;
